"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboxMock__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'maxSubmissionCost',
                type: 'uint256',
            },
        ],
        name: 'TicketData',
        type: 'event',
    },
    {
        inputs: [],
        name: 'activeOutbox',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'bridge',
        outputs: [
            {
                internalType: 'contract IBridge',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'maxSubmissionCost',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        name: 'createRetryableTicket',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'l2ToL1Sender',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'setL2ToL1Sender',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
const _bytecode = '0x6080604052600080546001600160a01b031916905534801561002057600080fd5b50610239806100306000396000f3fe60806040526004361061004a5760003560e01c806311b383ac1461004f578063679b6ded1461008457806380648b0214610141578063ab5d894314610172578063e78cea9214610172575b600080fd5b34801561005b57600080fd5b506100826004803603602081101561007257600080fd5b50356001600160a01b0316610187565b005b61012f600480360361010081101561009b57600080fd5b6001600160a01b038235811692602081013592604082013592606083013581169260808101359091169160a08201359160c081013591810190610100810160e08201356401000000008111156100f057600080fd5b82018360208201111561010257600080fd5b8035906020019184600183028401116401000000008311171561012457600080fd5b5090925090506101a9565b60408051918252519081900360200190f35b34801561014d57600080fd5b506101566101f0565b604080516001600160a01b039092168252519081900360200190f35b34801561017e57600080fd5b506101566101ff565b600080546001600160a01b0319166001600160a01b0392909216919091179055565b6040805188815290516000917f7efacbad201ebbc50ec0ce4b474c54b735a31b1bac996acff50df7de0314e8f9919081900360200190a15060009998505050505050505050565b6000546001600160a01b031690565b309056fea26469706673582212203c8b3c7ec6b7ef74f39e6a4b19e580fb893677c71e82fd65556281367e3ede6764736f6c634300060b0033';
class InboxMock__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.InboxMock__factory = InboxMock__factory;
InboxMock__factory.bytecode = _bytecode;
InboxMock__factory.abi = _abi;
